import GenerateBriefForm from "./GenerateBriefForm";
import PageHeader from "@/components/PageHeader";

const New: React.FC = () => {
  return (
    <>
      <div className="flex w-full flex-col items-start justify-start gap-10">
        <PageHeader
          backLink={{ href: "/briefs", text: "Back to all briefs" }}
          title="Generate a new sync brief"
        />
        <GenerateBriefForm
          formDescription="Fill in as many of the fields as you like, and we'll generate a new
          brief. Any fields left blank will be randomised by A.I."
          cta="Generate Brief"
        />
      </div>
    </>
  );
};

export default New;
